import type { RestClient } from "./restClient";

export interface LearningSettings {
  mode: "auto" | "manual";
  dialogue_threshold: number;
  user_id?: string;
  company_id?: string | null;
  updated_at?: string | null;
}

export class LearningSettingsApi {
  constructor(private client: RestClient) {}

  get(): Promise<LearningSettings> {
    return this.client.get("/v1/learning-settings");
  }

  update(body: { mode: "auto" | "manual"; dialogue_threshold: number }): Promise<LearningSettings> {
    return this.client.put("/v1/learning-settings", body);
  }
}
